// Theme preference: a per-browser convenience (light / dark / system).
export type ThemePreference = "light" | "dark" | "system";
const KEY = "ia-theme";

export function readTheme(): ThemePreference {
  try {
    const value = localStorage.getItem(KEY);
    return value === "light" || value === "dark" ? value : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(preference: ThemePreference) {
  const dark =
    preference === "dark" ||
    (preference === "system" && typeof matchMedia === "function" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", dark);
}

export function saveTheme(preference: ThemePreference) {
  try {
    if (preference === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, preference);
  } catch {
    // storage unavailable: preference lasts for this page only
  }
  applyTheme(preference);
}

const LAST_ORG = "ia-last-org";
export function rememberOrg(orgId: string) {
  try {
    localStorage.setItem(LAST_ORG, orgId);
  } catch {
    // ignore
  }
}
export function lastOrg(): string | null {
  try {
    return localStorage.getItem(LAST_ORG);
  } catch {
    return null;
  }
}
